import dayjs from 'dayjs';

export const getDateString = (date: any, isUnixTimestamp = false): string => {
  const wrappedDate = isUnixTimestamp ? dayjs.unix(date) : dayjs(date);
  const day = wrappedDate.date();
  const month = wrappedDate.format('MMM');
  const hour = wrappedDate.format('H:mm');
  const year = wrappedDate.format('YYYY');

  return `${hour}, ${month} ${day}, ${year}`;
};
